/**
 * AG Marquee Slider — seamless infinite horizontal scroll (no visible rewind).
 */
(function () {
  'use strict';

  if (window.__AG_MARQUEE_SLIDER_LOADED__) {
    return;
  }

  window.__AG_MARQUEE_SLIDER_LOADED__ = true;

  function getTrackGap(track) {
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap);
    return Number.isNaN(gap) ? 0 : gap;
  }

  function measureLoopWidth(track, originalItems) {
    if (!originalItems.length) {
      return 0;
    }

    var gap = getTrackGap(track);
    var width = 0;

    originalItems.forEach(function (item, index) {
      width += item.getBoundingClientRect().width;
      if (index < originalItems.length - 1) {
        width += gap;
      }
    });

    width += gap;
    return width;
  }

  function initMarqueeSlider(slider, options) {
    if (!slider || slider.dataset.agMarqueeInit === 'true') {
      return;
    }

    options = options || {};
    var track = slider.querySelector(options.trackSelector);

    if (!track) {
      return;
    }

    if (options.fixedTrackClass && track.classList.contains(options.fixedTrackClass)) {
      return;
    }

    var originalItems = Array.prototype.slice.call(
      track.querySelectorAll(options.itemSelector)
    );

    if (!originalItems.length) {
      return;
    }

    slider.dataset.agMarqueeInit = 'true';
    track.style.transition = 'none';

    var speed = typeof options.speed === 'number' ? options.speed : 50;
    var loopWidth = measureLoopWidth(track, originalItems);
    var offset = 0;
    var lastTime = null;
    var rafId = null;
    var running = false;
    var paused = false;

    function applyTransform() {
      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
    }

    function tick(time) {
      if (!running) {
        return;
      }

      if (paused) {
        lastTime = null;
        rafId = window.requestAnimationFrame(tick);
        return;
      }

      if (lastTime === null) {
        lastTime = time;
      }

      var delta = Math.min(time - lastTime, 50);
      lastTime = time;
      offset += (speed * delta) / 1000;

      if (loopWidth > 0) {
        while (offset >= loopWidth) {
          offset -= loopWidth;
        }
      }

      applyTransform();
      rafId = window.requestAnimationFrame(tick);
    }

    function start() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      if (running) {
        return;
      }

      running = true;
      lastTime = null;
      rafId = window.requestAnimationFrame(tick);
    }

    function stop() {
      running = false;
      paused = false;

      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    function pause() {
      paused = true;
    }

    function resume() {
      paused = false;
      lastTime = null;
    }

    function remeasure() {
      loopWidth = measureLoopWidth(track, originalItems);

      if (loopWidth > 0) {
        offset = offset % loopWidth;
      } else {
        offset = 0;
      }

      applyTransform();
    }

    slider.addEventListener('mouseenter', pause);
    slider.addEventListener('mouseleave', resume);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
          } else {
            stop();
          }
        });
      });

      observer.observe(slider);
    } else {
      start();
    }

    window.addEventListener('resize', remeasure, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(remeasure).catch(function () {});
    }

    window.setTimeout(remeasure, 100);
    applyTransform();
  }

  function initCollection(selector, options) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (slider) {
      var speed = parseFloat(slider.getAttribute('data-marquee-speed'));
      var config = Object.assign({}, options);

      if (!Number.isNaN(speed) && speed > 0) {
        config.speed = speed;
      }

      initMarqueeSlider(slider, config);
    });
  }

  window.AGMarqueeSlider = {
    init: initMarqueeSlider,
    initCollection: initCollection
  };

  document.addEventListener('DOMContentLoaded', function () {
    initCollection('.ag-gradient-banner__slider[data-auto-scroll="true"]', {
      trackSelector: '.ag-gradient-banner__track',
      itemSelector: '.ag-gradient-banner__item:not(.ag-gradient-banner__item--duplicate)',
      fixedTrackClass: '',
      speed: 45
    });

    initCollection('.ag-review-bar-migration__slider[data-auto-scroll="true"]', {
      trackSelector: '.ag-review-bar-migration__track',
      itemSelector: '.ag-review-bar-migration__item:not(.ag-review-bar-migration__item--duplicate)',
      fixedTrackClass: 'ag-review-bar-migration__track--fixed',
      speed: 50
    });
  });
})();
